import React, { Fragment, useContext } from 'react';
import { TabContent, TabPane } from 'reactstrap';
import { FollowUp, Favourites, Ideas, Business, Holidays, Important } from '../../../../Constant';
import HistoryClass from './History';
import NoDataFoundClass from './NoDataFound';
import OrgenizationTab from './OrgenizationTab';
import PersonalTab from './PersonalTab';
import ContactAppContext from '../../../../_helper/Contact';

const TabComponent = ({ activeTab, pinagareSupervisorList }) => {
    const { users } = useContext(ContactAppContext);

    return (
        <Fragment>
            <TabContent activeTab={activeTab}>

                <TabPane tabId="1">
                    <PersonalTab eng={"ps_approver"} supervisors={pinagareSupervisorList.ps_approver} />
                </TabPane>
                <TabPane tabId="2">
                    <PersonalTab eng={"general_approver"} supervisors={pinagareSupervisorList.general_approver} />
                </TabPane>
                <TabPane tabId="3">
                    {/*<NoDataFoundClass title={" Board Members"} />*/}
                    <PersonalTab eng={"committee_approver"} supervisors={pinagareSupervisorList.committee_approver} />
                </TabPane>
				<TabPane tabId="4">
                  <PersonalTab eng={"psp_approver"} supervisors={pinagareSupervisorList.psp_approver} />
                </TabPane>				
                
            </TabContent>
        </Fragment>
    );
};

export default TabComponent;